var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpgrade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.75C8.54822 1.75 5.75 4.54822 5.75 8C5.75 11.4518 8.54822 14.25 12 14.25C15.4518 14.25 18.25 11.4518 18.25 8C18.25 4.54822 15.4518 1.75 12 1.75ZM4.25 8C4.25 3.71979 7.71979 0.25 12 0.25C16.2802 0.25 19.75 3.71979 19.75 8C19.75 12.2802 16.2802 15.75 12 15.75C7.71979 15.75 4.25 12.2802 4.25 8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6914 13.1366C16.102 13.0821 16.479 13.3708 16.5335 13.7814L17.7435 22.9014C17.7814 23.1869 17.6525 23.4688 17.4117 23.6269C17.171 23.785 16.8611 23.7913 16.6141 23.6432L12 20.8747L7.38589 23.6432C7.13894 23.7914 6.82895 23.785 6.58824 23.6269C6.34753 23.4688 6.21863 23.1868 6.25655 22.9013L7.46655 13.7913C7.52108 13.3807 7.89816 13.0921 8.30877 13.1466C8.71937 13.2011 9.00803 13.5782 8.95349 13.9888L7.94835 21.5564L11.6141 19.3569C11.8517 19.2144 12.1484 19.2144 12.3859 19.3569L16.0519 21.5566L15.0465 13.9787C14.9921 13.5681 15.2808 13.1911 15.6914 13.1366Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgrade);
export default __webpack_public_path__ + "static/media/upgrade.7ee617b1.svg";
export { ForwardRef as ReactComponent };